import React from 'react';
import PropTypes from 'prop-types';
import PublicPageWrapper from '../components/Public/PublicPageWrapper';
import AuthFormContainer from '../components/Auth/AuthFormContainer/AuthFormContainer';
import AuthButton from '../components/Auth/AuthButton/AuthButton';
import Loader from '../components/UI/Loader/Loader';

class ErrorBoundary extends React.Component {
  state = {
    error: null,
    swUpdate: false,
  };

  static getDerivedStateFromError(error) {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    const requireMessage = /Cannot read property 'call' of undefined/;
    if (chunkFailedMessage.test(error.message) || requireMessage.test(error.message)) {
      return { error: null, swUpdate: true };
    }
    return { error, swUpdate: false };

    // Update state so the next render will show the fallback UI.
  }

  componentDidCatch(error) {
    console.log(error.message);
  }

  render() {
    const { error, swUpdate } = this.state;
    const { children } = this.props;
    if (swUpdate) {
      // You can render any custom fallback UI
      window.location.reload();
      return <Loader />;
    }
    if (error !== null) {
      // You can render any custom fallback UI
      return (
        <PublicPageWrapper
          isUser={false}
          logoClickable={false}
        >
          <AuthFormContainer className="centered mt-5 h-100 flex-column mx-auto">
            <h1>Floquote has crashed</h1>
            <p className="text-secondary">
              Error Message:
              {' '}
              {error.message || 'Something went wrong'}
            </p>
            <p className="text-center">
              We will work hard to find a solution to this issue.
              If you would like to try refreshing the Floquote app please
              click the &quot;refresh page&quot; button below.
            </p>
            <AuthButton variant="secondary" onClick={() => window.location.reload()}>Refresh Page</AuthButton>
          </AuthFormContainer>
        </PublicPageWrapper>
      );
    }

    return children;
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.node,
};

ErrorBoundary.defaultProps = {
  children: '',
};

export default ErrorBoundary;
